import React from 'react';
import NextLink from 'next/link';
import classNames from 'classnames';
import { getBackgroundProp, resolveSetting } from '../../../utils/settingsHelper';
import { Text } from '../Text/Text';
import { roundedOptions, shadowOptions } from '../../editor/Toolbar/options';
import Image from '../Image/Image';
import Icon from './Icon';
import Flag from '../../static/Flag';

export const defaultLinkProps = {
	background: 'buttonBackground',
	background2: 'buttonBackground2',
	color: 'buttonColor',
	rounded: 'buttonRounded',
	padding: ['8', '12', '8', '12'],
	margin: ['5', '0', '5', '0'],
	borderWidth: 'buttonBorderWidth',
	borderColor: 'buttonBorderColor',
};

export const transparentLinkProps = {
	background: 'transparent',
	background2: '',
	color: 'color',
	text: 'Link',
	borderWidth: 0,
};
export const getLinkStyle = (props, settings) => {
	const { color, padding, borderWidth, borderColor } = props;
	return {
		background: getBackgroundProp(props, settings),
		color: resolveSetting(color, settings),
		borderWidth: `${resolveSetting(borderWidth, settings)}px`,
		borderColor: resolveSetting(borderColor, settings),
		// margin: margin ? `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px` : undefined,
		padding: padding ? `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px` : '',
	};
};

export const getLinkClasses = (props, settings) => classNames(
	{ [roundedOptions[resolveSetting(props.rounded, settings)]]: !!resolveSetting(props.rounded, settings) },
	{ [shadowOptions[resolveSetting(props.shadow, settings)]]: !!resolveSetting(props.rounded, settings) },
);

export function Link(props) {
	const { href, settings, text, textComponent, image, height, width, imageComponent, targetBlank, src, iconBefore, textCenter } = props;

	return (
		<NextLink
			style={getLinkStyle(props, settings)}
			className={classNames(
				getLinkClasses(props, settings),
				textCenter ? 'block' : 'inline-flex',
				'hover:opacity-75',
			)}
			target={targetBlank ? '_blank' : undefined}
			href={href.includes('/') ? href : `/${href}`}
		>
			<div className="inline-flex items-center align-middle text-center gap-x-2">
				{iconBefore && (iconBefore.length === 2 ? <Flag code={iconBefore} /> : <Icon value={iconBefore} />)}
				{image ? <Image {...imageComponent} height={height} width={width} src={src} className="h-12" />
					: <Text {...textComponent} text={text} textAlign="left" />}
			</div>
		</NextLink>
	);
}
